import React from 'react'
import { Container   } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
//import ReactImageMagnify from 'react-image-magnify';
import h from './img/20.png'
import hh from './img/21.png'
import hhh from './img/22.png'
import hhhh from './img/23.png'
import hhhhh from './img/24.png'
import hhhhhh from './img/25.png'
import hhhhhhh from './img/26.png'
import hhhhhhhh from './img/27.png'
import hhhhhhhhh from './img/28.png'
import hhhhhhhhhh from './img/29.png'
import hhhhhhhhhhh from './img/30.png'
import hhhhhhhhhhhh from './img/31.png'
import hhhhhhhhhhhhh from './img/32.png'
///import watchImg300 from './img/watc.png'
//import watchImg1200 from './img/watc.png'
import './customers.css';

const images = [h, hhhhhhhhhhh, hhh, hhhh, hhhhhhhhhhhhh, hhhhhhh, hhhhhhhhhh, hhhhhh, hh, hhhhhhhh, hhhhhhhhhhhh, hhhhhhhhh, hhhhh];


export const customers = () => (

<div className="marquee-wrapper">

  {/* שורה 1 */}
  <div className="marquee-container">
    <div className="marquee-content">
      {images.map((imgSrc, index) => (
        <div className="marquee-item" key={`row1-first-${index}`}>
          <img src={imgSrc} className="customer-img" alt="customer" />
        </div>
      ))}

      {images.map((imgSrc, index) => (
        <div className="marquee-item" key={`row1-second-${index}`}>
          <img src={imgSrc} className="customer-img" alt="customer" />
        </div>
      ))}
    </div>
  </div>

  {/* שורה 2 */}
  <div className="marquee-container reverse">
    <div className="marquee-content">
      {images.map((imgSrc, index) => (
        <div className="marquee-item" key={`row2-first-${index}`}>
          <img src={imgSrc} className="customer-img" alt="customer" />
        </div>
      ))}

      {images.map((imgSrc, index) => (
        <div className="marquee-item" key={`row2-second-${index}`}>
          <img src={imgSrc} className="customer-img" alt="customer" />
        </div>
      ))}
    </div>
  </div>

  {/* שורה 3 */}
  <div className="marquee-container">
    <div className="marquee-content slow">
      {images.map((imgSrc, index) => (
        <div className="marquee-item" key={`row3-first-${index}`}>
          <img src={imgSrc} className="customer-img" alt="customer" />
        </div>
      ))}

      {images.map((imgSrc, index) => (
        <div className="marquee-item" key={`row3-second-${index}`}>
          <img src={imgSrc} className="customer-img" alt="customer" />
        </div>
      ))}
    </div>
    
  </div>
    {/* שורה 4 */}
  <div className="marquee-container">
    <div className="marquee-content slow">
      {images.map((imgSrc, index) => (
        <div className="marquee-item" key={`row3-first-${index}`}>
          <img src={imgSrc} className="customer-img" alt="customer" />
        </div>
      ))}

      {images.map((imgSrc, index) => (
        <div className="marquee-item" key={`row3-second-${index}`}>
          <img src={imgSrc} className="customer-img" alt="customer" />
        </div>
      ))}
    </div>
    
  </div>
</div>



  
);




///<div style={{width:'442px',height:'113px'}} >
///<ReactImageMagnify {...{
 //   smallImage: {
  //      alt: 'Wristwatch by Ted Baker London',
  //      isFluidWidth: true,
   //     src: watchImg300
 //   },
//   largeImage: {
   //   src: watchImg1200,
  //    width: 1200,
  //    height: 1800
 // }
//}} />
///</div>